<template>
  <CategoryCarousel
    v-for="category in categories"
    :key="category"
    :category="category"
  />
</template>

<script>
import CategoryCarousel from "@/components/layout/Video/CategoryCarousel";
export default {
  name: "FeaturedCategories",
  props:{
    categories: {
      type: Array,
      required: true,
    },
  },
  components: {
    CategoryCarousel,
  },
};
</script>

<style>
</style>